import { ModulesMap, ModulesConfigMap } from '@/config/data/modulesMaps'
import { _apiRequestWrap } from '../apiService'

function _getMachinePhotos(options = {}) {
	return _apiRequestWrap(
		ModulesMap.MACHINE_PHOTOS,
		ModulesConfigMap[ModulesMap.MACHINE_PHOTOS].GET_PHOTOS,
		options
	)
}

function _createMachinePhoto(options = {}) {
	return _apiRequestWrap(
		ModulesMap.MACHINE_PHOTOS,
		ModulesConfigMap[ModulesMap.MACHINE_PHOTOS].CREATE_PHOTO,
		options
	)
}

function _getMachinePhoto(options = {}) {
	return _apiRequestWrap(
		ModulesMap.MACHINE_PHOTOS,
		ModulesConfigMap[ModulesMap.MACHINE_PHOTOS].GET_PHOTO,
		options
	)
}

function _patchMachinePhoto(options = {}) {
	return _apiRequestWrap(
		ModulesMap.MACHINE_PHOTOS,
		ModulesConfigMap[ModulesMap.MACHINE_PHOTOS].PATCH_PHOTO,
		options
	)
}

function _putMachinePhoto(options = {}) {
	return _apiRequestWrap(
		ModulesMap.MACHINE_PHOTOS,
		ModulesConfigMap[ModulesMap.MACHINE_PHOTOS].PUT_PHOTO,
		options
	)
}

function _deleteMachinePhoto(options = {}) {
	return _apiRequestWrap(
		ModulesMap.MACHINE_PHOTOS,
		ModulesConfigMap[ModulesMap.MACHINE_PHOTOS].DELETE_PHOTO,
		options
	)
}

export default {
	[ModulesConfigMap[ModulesMap.MACHINE_PHOTOS].GET_PHOTOS]: _getMachinePhotos,

	[ModulesConfigMap[ModulesMap.MACHINE_PHOTOS].CREATE_PHOTO]: _createMachinePhoto,
	[ModulesConfigMap[ModulesMap.MACHINE_PHOTOS].GET_PHOTO]: _getMachinePhoto,
	[ModulesConfigMap[ModulesMap.MACHINE_PHOTOS].PATCH_PHOTO]: _patchMachinePhoto,
	[ModulesConfigMap[ModulesMap.MACHINE_PHOTOS].PUT_PHOTO]: _putMachinePhoto,
	[ModulesConfigMap[ModulesMap.MACHINE_PHOTOS].DELETE_PHOTO]: _deleteMachinePhoto,
}
